<template>
  <v-container class="component_main px-6">
    <v-row class="ma-0">
      <v-col class="" cols="12" sm="12" md="12">
        <h1>Gerenciar feriados</h1>
        <p>Cadastre feriados regionais.</p>
      </v-col>
      <v-col class="py-0" cols="12" sm="12" md="6">
        <FeriadoForm 
          :sendForm="(form) => addFeriados(form)"
          :showBtn="showBtn"
          :sendPrestador="(flt) => sendPrestador(flt)"   
          :prestadores="prestadores"
        />
      </v-col>
      <v-col class="py-0" cols="12" sm="12" md="6">
        <FeriadoList
          :list="feriadosList"
          :delItem="(obj) => deleteFeriados(obj)"
          :selectYear="(date) => getFeriado(date)"
          :YearCurrent="year"
          :addFeriados="(form) => addFeriados(form)"
          :showBtn="showBtn"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import FeriadoForm from "@/components/faturamento/agenda/FeriadoForm"
import FeriadoList from "@/components/faturamento/agenda/FeriadoList"
export default {
  components: {
    FeriadoForm,
    FeriadoList
  },
  data() {
    return {
      filteredList: [],
      prestadores: [],
      prestador_id: null,
      showBtn: false,
      year: null,
    };
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      feriadosList: (state) => state.common.feriadosList,
    }),
  },
  mounted() {
    this.prestadores = this.$store.getters["permissions/getPrestadoresByGeco"]()
  },
  methods: {
    ...mapActions("common", ["getFeriados", "addFeriado", "deleteFeriado"]),
    sendPrestador(val) {
      this.prestador_id = val.prestador_id
      this.getFeriado(val.year)
    },
    getFeriado(date) {
      if(!this.prestador_id){
        return true
      }
      this.showBtn = true
      this.year = date;
      let opts = {
        grupo_economico: this.grupoEconomico,
        prestador_id: this.prestador_id,
        dt_inicio: `${date}-01-01`,
        dt_fim: `${date}-12-31`,
        referenceYear: date
      };
      this.getFeriados(opts);
    },
    addFeriados(formData) {
      let opts = {}
      if (formData.descricao && formData.dt_feriado) {
        opts = {
          yearSelect: formData.year,
          acao: "addferiado",
          payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: this.prestador_id,
            descricao: formData.descricao,
            dt_feriado: formData.dt_feriado,
          },
        };
        // this.addFeriado(opts);
      } else {
        opts = {
          yearSelect: formData.year,
          acao: "addferiadosnacionais",
          payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: this.prestador_id,
            ano: formData.year,
          },
        };
      }
      this.addFeriado(opts).then(()=>this.getFeriado(formData.year));
    },
    deleteFeriados(obj) {
      let opts = {
        grupo_economico: this.grupoEconomico,
        id: obj.id,
        year: obj.year,
      };
      this.deleteFeriado(opts).then(()=>this.getFeriado(opts.year))
      
    },
  },
};
</script>

<style>
</style>